module.exports = __webpack_public_path__ + "static/media/account2x.32c96206.png";